import React, {useState} from 'react';
import styled from "styled-components";
import {
    Button,
    Col,
    Dropdown,
    DropdownMenu,
    DropdownToggle,
    FormGroup,
    Input,
    Label,
    Media,
    Nav,
    UncontrolledDropdown,
} from "reactstrap";
import Select from "react-select";
import {DropdownIndicator} from "@pages/components/DropDownIndicator";

const SortContainer = styled.div`
   cursor: pointer;
`
const FilterContainer = styled.div`
  display:flex;
`
const SortText = styled.span``

const SortIcon = styled.img`
 transform: ${props => props.iconPosition === 0 ? 'rotate(0)' : 'rotate(180deg)'} ;
 width: 20px;
 height: 20px;
`

const FilterItemsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 15px;
    width: ${props => props.width};
`

const KeySelect = ({
                            label,
                            value,
                            onChange,
                            options,
                            disabled,
                            readOnly,
                            defaultOption,
                            required = false,
                            invalid,
                            errorMessage
                        }) => {
    const selectValue = (data) => {
        if (data.target.value === '-') {
            data.target.value = null
            return onChange(data)
        } else onChange(data)
    }
    return (
        <FormGroup className={'d-flex align-items-center g-5'}>
            <label className="form-control-label w-50">{label} {required ? <span className={'required-dot'}>*</span> : ''}</label>
          <div className={'w-100'}>
              <Input
                  type="select"
                  value={value === null ? '-' : value}
                  onChange={selectValue}
                  disabled={disabled}
                  readOnly={readOnly}
                  invalid={invalid}
              >
                  {defaultOption && <option>-</option>}
                  {options &&
                  Object.keys(options).map(key => {
                      return <option value={key} key={key}>{options[key]}</option>
                  })
                  }
              </Input>
              <div className="invalid-feedback">
                  {errorMessage}
              </div>
          </div>
        </FormGroup>
    )
}
const InputAddressSelect = ({
                                value,
                                onChange,
                                options = [],
                                disabled,
                                readOnly,
                                required = false,
                                invalid = false,
                                errorMessage = ''
                            }) => {
    const formattedOptions = [
        { value: '', label: '-' },
        ...options.map((item) => ({
            value: item.Udprn?.toString(),
            label: item.SummaryAddress
        }))
    ];

    const selectedOption =
        formattedOptions.find((opt) => `${opt.value}` === `${value}`) || null;

    const handleChange = (selected) => {
        const selectedValue = selected?.value || '';
        const matchedAddress = options.find(
            (item) => item.Udprn?.toString() === selectedValue
        );
        onChange({
            target: {
                value: selectedValue,
                fullAddress: matchedAddress || null
            }
        });
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '46px',
            borderColor: invalid ? '#dc3545' : base.borderColor,
            boxShadow: 'none',
            '&:hover': {
                borderColor: invalid ? '#dc3545' : base.borderColor
            }
        })
    };

    return (
        <FormGroup className="d-flex align-items-center">
            <label className="form-control-label w-50">
                Correspondent address {required && <span className="required-dot">*</span>}
            </label>
            <div className="w-100">
                <Select
                    value={selectedOption}
                    onChange={handleChange}
                    options={formattedOptions}
                    isDisabled={disabled || readOnly || !options.length}
                    isClearable={false}
                    placeholder="Select correspondent address"
                    styles={customStyles}
                    components={{
                        DropdownIndicator,
                        IndicatorSeparator: () => null
                    }}
                    classNamePrefix="react-select"
                    className={invalid ? 'is-invalid' : ''}
                />
                {invalid && <div className="invalid-feedback d-block">{errorMessage}</div>}
            </div>
        </FormGroup>
    );
};

const InputKeySelect = ({
                            label,
                            newLabel,
                            value,
                            onChange,
                            options,
                            disabled,
                            readOnly,
                            defaultOption,
                            invalid,
                            required = false,
                            errorMessage,
                            targetShow = null
                        }) => {
    const formattedOptions = [
        ...(defaultOption ? [{ value: null, label: '-' }] : []),
        ...Object.keys(options || {}).map(key => ({
            value: key,
            label: options[key],
        }))
    ];

    const selectedOption = formattedOptions.find(opt => `${opt.value}` === `${value}`) || null;

    const handleChange = (selected) => {
        onChange({
            target: {
                value: selected ? selected.value : null,
            }
        });
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '46px',
            borderColor: invalid ? '#dc3545' : base.borderColor,
            boxShadow: 'none',
            '&:hover': {
                borderColor: invalid ? '#dc3545' : base.borderColor,
            },
        }),
    };

    return (
        <FormGroup className={newLabel ? 'd-flex align-items-center' : ''}>
            {label && !newLabel && (
                <label className="form-control-label">
                    {label}
                </label>
            )}
            {newLabel && (
                <label className="form-control-label w-50">
                    {newLabel} {required && <span className="required-dot">*</span>}
                </label>
            )}
            <div className="w-100">
                <Select
                    value={selectedOption}
                    onChange={handleChange}
                    menuPortalTarget={targetShow}
                    menuPosition="fixed"
                    options={formattedOptions}
                    isDisabled={disabled || readOnly}
                    isClearable={false}
                    placeholder="-"
                    styles={customStyles}
                    components={{
                        DropdownIndicator,
                        IndicatorSeparator: () => null,
                    }}
                    classNamePrefix="react-select"
                    className={invalid ? 'is-invalid' : ''}
                />
                {invalid && <div className="invalid-feedback d-block">{errorMessage}</div>}
            </div>
        </FormGroup>
    );
};



const InputArraySelect = ({
                              label,
                              required = false,
                              value,
                              onChange,
                              options = [],
                              disabled,
                              readOnly,
                              defaultOption,
                              defaultOptionText = '-',
                              valueKey,
                              labelKey,
                              newLabel,
                              labelKey2,
                              invalid,
                              multiple = false,
                              targetShow = null,
                          }) => {
    const handleSelectChange = (selected) => {
        if (multiple) {
            const newValue = selected ? selected.map(opt => opt.value) : [];
            onChange({ target: { value: newValue } });
        } else {
            const newValue = selected ? selected.value : null;
            onChange({ target: { value: newValue } });
        }
    };
    const getSelectedOption = () => {
        if (multiple && Array.isArray(value)) {
            return formattedOptions.filter(opt => value.includes(opt.value));
        } else {
            return formattedOptions.find(opt => opt.value === value) || null;
        }
    };
    const formattedOptions = options?.map(opt => ({
        value: opt[valueKey],
        label: labelKey2 ? `${opt[labelKey]}, ${opt[labelKey2].name}` : opt[labelKey],
        raw: opt,
    }));
    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '46px',
            borderColor: invalid ? '#dc3545' : base.borderColor,
            boxShadow: 'none',
            '&:hover': {
                borderColor: invalid ? '#dc3545' : base.borderColor,
            },
        }),
    };
    return (
        <FormGroup className={newLabel ? 'd-flex align-items-center' : ''}>
            {label && !newLabel && (
                <label className="form-control-label">
                    {label}
                </label>
            )}
            {newLabel && (
                <label className="form-control-label w-50">
                    {newLabel} {required && <span className="required-dot">*</span>}
                </label>
            )}
            <div className="w-100">
                <Select
                    menuPortalTarget={targetShow}
                    value={getSelectedOption()}
                    onChange={handleSelectChange}
                    options={formattedOptions}
                    isDisabled={disabled || readOnly}
                    isClearable={!multiple && !!defaultOption}
                    placeholder={defaultOptionText}
                    styles={customStyles}
                    isMulti={multiple}
                    components={{
                        DropdownIndicator,
                        IndicatorSeparator: () => null,
                    }}
                    classNamePrefix="react-select"
                    className={invalid ? 'is-invalid' : ''}
                />
            </div>
        </FormGroup>
    )
}

const ArraySelect = ({
                         label,
                         required = false,
                         value,
                         onChange,
                         options = [],
                         disabled,
                         readOnly,
                         defaultOption,
                         valueKey,
                         labelKey,
                         labelKey2,
                         invalid,
                         noBottom = false,
                         errorMessage
                     }) => {
    const formattedOptions = [
        ...(defaultOption ? [{ value: null, label: '-' }] : []),
        ...options.map((item) => {
            if (typeof item === 'string' || typeof item === 'number') {
                return { value: item, label: item };
            }
            return {
                value: item[valueKey],
                label: labelKey2
                    ? `${item[labelKey]}, ${item[labelKey2]?.name || ''}`
                    : item[labelKey],
            };
        })
    ];

    const selectedOption = formattedOptions.find(opt => `${opt.value}` === `${value}`) || null;

    const handleChange = (selected) => {
        onChange({
            target: {
                value: selected ? selected.value : null
            }
        });
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '46px',
            borderColor: invalid ? '#dc3545' : base.borderColor,
            boxShadow: 'none',
            '&:hover': {
                borderColor: invalid ? '#dc3545' : base.borderColor,
            },
        }),
    };

    return (
        <FormGroup className={'d-flex align-items-center' + (noBottom ? ' mb-0' : '')}>
            <label className="form-control-label w-50">
                {label} {required && <span className="required-dot">*</span>}
            </label>
            <div className="w-100">
                <Select
                    value={selectedOption}
                    onChange={handleChange}
                    options={formattedOptions}
                    isDisabled={disabled || readOnly}
                    isClearable={false}
                    placeholder="-"
                    styles={customStyles}
                    components={{
                        DropdownIndicator,
                        IndicatorSeparator: () => null,
                    }}
                    classNamePrefix="react-select"
                    className={invalid ? 'is-invalid' : ''}
                />
                {invalid && <div className="invalid-feedback d-block">{errorMessage}</div>}
            </div>
        </FormGroup>
    );
};
const InputKeySideSelect = ({
                                label,
                                value,
                                onChange,
                                options,
                                disabled,
                                readOnly,
                                defaultOption,
                                invalid,
                                required = false,
                                errorMessage
                            }) => {

    const formattedOptions = [
        ...(defaultOption ? [{ value: null, label: '-' }] : []),
        ...Object.keys(options || {}).map(key => ({
            value: key,
            label: options[key],
        }))
    ];

    const selectedOption = formattedOptions.find(opt => `${opt.value}` === `${value}`) || null;
    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '46px',
            borderColor: invalid ? '#dc3545' : base.borderColor,
            boxShadow: 'none',
            '&:hover': {
                borderColor: invalid ? '#dc3545' : base.borderColor,
            },
        }),
    };
    return (
        <FormGroup className="row">
            <Label
                className="form-control-label"
                md="3"
            >
                {label}  {required ? <span className={'required-dot'}>*</span> : ''}
            </Label>
            <Col md="7">
                <Select
                    value={selectedOption}
                    onChange={(value)=>{
                        onChange(
                                {target:
                                            {
                                       value: value.value
                                      }
                           }
                        )
                    }}
                    menuPosition="fixed"
                    options={formattedOptions}
                    isDisabled={disabled || readOnly}
                    isClearable={false}
                    placeholder="-"
                    styles={customStyles}
                    components={{
                        DropdownIndicator,
                        IndicatorSeparator: () => null,
                    }}
                    classNamePrefix="react-select"
                    className={invalid ? 'is-invalid' : ''}
                />
                <div className="invalid-feedback">
                    {errorMessage}
                </div>
            </Col>
        </FormGroup>
    )
}

const InputArraySideSelect = ({
                                  label,
                                  value,
                                  onChange,
                                  options = [],
                                  disabled,
                                  readOnly,
                                  valueKey,
                                  labelKey,
                                  labelKey2,
                                  invalid,
                                  required,
                                  errorMessage
                              }) => {
    const getSelectedOption = () => {
        return options.find(option => option[valueKey] === value) || null;
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: '46px',
            borderColor: invalid ? '#dc3545' : base.borderColor,
            boxShadow: 'none',
            '&:hover': {
                borderColor: invalid ? '#dc3545' : base.borderColor,
            },
        }),
    };
    const formatOptionLabel = (option) => {
        return <div className={'cursor-pointer'}>{
            option?.icon ?
                <img height='25px' width='25px'
                     src={require(`assets/images/${option?.icon}`)} alt=""/>
                : <></>
        }
            {labelKey !== null ? <span>{option[labelKey]}</span> : <span>{option}</span>}
        </div>
    };
    return (
        <FormGroup className="row">
            <Label className="form-control-label" md="3">
                {label}{required && <span className="required-dot">*</span>}
            </Label>
            <Col md="7">
                <Select
                    styles={customStyles}
                    options={options}
                    isClearable={true}
                    getOptionLabel={option =>
                        labelKey2
                            ? `${option[labelKey]}, ${option[labelKey2]?.name || ''}`
                            : option[labelKey]
                    }
                    getOptionValue={option => option[valueKey]}
                    formatOptionLabel={formatOptionLabel}
                    components={{
                        IndicatorSeparator: () => null,
                        DropdownIndicator
                    }}
                    isSearchable={true}
                    placeholder={label}
                    value={getSelectedOption()}
                    onChange={selected => {
                        onChange({
                            target: {
                                value: selected ? selected[valueKey] : ''
                            }
                        });
                    }}
                    isDisabled={disabled || readOnly}
                    classNamePrefix={invalid ? 'is-invalid' : ''}
                />
                {invalid && <div className="invalid-feedback d-block">{errorMessage}</div>}
            </Col>
        </FormGroup>
    )
}

const SelectWithoutInput = ({
                                label,
                                onSelect,
                                options = [],
                                imageLink,
                                fullWidth = false,
                                withBorder = false,
                                labelKey = null,
                                valueKey,
                                wholeData = false
                            }) => {

    const normalizeOptions = (optionsList) => {
        return (optionsList || []).map((opt,index) => {
            if (typeof opt === 'string' || typeof opt === 'number') {
                return { label: opt, value: opt };
            }
            return {
                ...opt,
                label: labelKey ? opt[labelKey] : opt.label ?? '',
                value: valueKey ? opt[valueKey] : opt.value ?? '',
                index,
            };
        });
    };

    const normalizedOptions = normalizeOptions(options);
    const formatOptionLabel = (option) => (
        <div className="cursor-pointer d-flex align-items-center gap-2">
            {option?.icon && (
                <img height="25px" width="25px" src={require(`assets/images/${option.icon}`)} alt="" />
            )}
            <span>{option.label}</span>
        </div>
    );


    const styles = {
        control: base => ({
            ...base,
            border: '1px solid #ccc',
            borderRadius: '8px',
            justifyContent: 'left',
            flexWrap: 'nowrap',
        }),
        menu: base => ({
            ...base,
            minWidth: '150px',
            zIndex: 1021
        }),
    }


    return (
        <div className={"d-flex align-items-center " + (fullWidth ? "w-100" : "") + (withBorder ? " selectBorder" : "")}>
            {imageLink && <img height='25px' width='25px' src={require(`assets/images/${imageLink}`)} alt=""/>}
                <div className={'w-100'}>
                    <Select
                        styles={styles}
                        options={normalizedOptions}
                        isClearable={true}
                        formatOptionLabel={formatOptionLabel}
                        components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator
                        }}
                        isSearchable={true}
                        placeholder={label}
                        onChange={value => {
                            if (wholeData) {
                                onSelect(value || '')
                            } else {
                                onSelect( value ? value?.value : '')
                            }

                        }}
                    />
                </div>
        </div>
    )
}
const CustomSort = ({
                        label, value, onSelect,
                        imageLink,
                    }) => {
    const selectValue = () => {
        onSelect(Number(!value))
    }
    return (
        <Nav className="align-items-center ml-auto ml-md-0" navbar>
            <SortContainer onClick={selectValue}>
                <SortIcon iconPosition={value} src={require(`assets/images/${imageLink}`)}/>
                <SortText>{label}</SortText>
            </SortContainer>
        </Nav>
    )
}
const CustomFilter = ({
                          regNos = [], departments = [], assignees = [], priorities = [], onChange
                      }) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [filter, setFilter] = useState({})
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    return (
        <Nav className="align-items-center ml-auto ml-md-0" navbar>
            <UncontrolledDropdown nav>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>

                    <DropdownToggle className="nav-link pr-0" color="" tag="a" style={{cursor: 'pointer'}}>
                        <Media className="align-items-center">
                            <img height='25px' width='25px' src={require(`assets/images/filter_alt.png`)} alt=""/>
                            <Media className="ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">
                      Filter Bar
                      </span>
                                <i className="ni ni-up rotate-down"/>
                            </Media>
                        </Media>
                    </DropdownToggle>
                    <DropdownMenu style={{position: 'absolute', cursor: 'pointer', padding: '25px'}}>
                        <FilterContainer>
                            <FilterItemsContainer width='135px'>
                                <FilterContainer>
                                    <img height='25px' width='25px'
                                         src={require(`assets/images/directions_car_grey.png`)} alt=""/>
                                    <span>Reg. Number</span>
                                </FilterContainer>
                                <FilterContainer>
                                    <img height='25px' width='25px'
                                         src={require(`assets/images/taskEdit/group_grey.png`)} alt=""/>
                                    <span>Department</span>
                                </FilterContainer>
                                <FilterContainer>
                                    <img height='25px' width='25px' src={require(`assets/images/taskEdit/person.png`)}
                                         alt=""/>
                                    <span>Worker</span>
                                </FilterContainer>
                                <FilterContainer>
                                    <img height='25px' width='25px' src={require(`assets/images/taskEdit/priority.png`)}
                                         alt=""/>
                                    <span>Priority</span>
                                </FilterContainer>
                            </FilterItemsContainer>
                            <FilterItemsContainer width='230px'>
                                <Select
                                    options={regNos}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    placeholder={'Reg. Number'}
                                    onChange={value => {
                                        setFilter({...filter, regNo: value.stock_no})
                                    }}
                                />
                                <Select
                                    options={departments}
                                    className="basic-single"
                                    getOptionLabel={option => option.text}
                                    getOptionValue={option => option.value}
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    placeholder={'Departments'}
                                    onChange={value => {
                                        setFilter({...filter, department: value.value})
                                    }}
                                />
                                <Select
                                    options={assignees}
                                    getOptionLabel={option => option.name}
                                    getOptionValue={option => option.id}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    placeholder={'Workers'}
                                    onChange={value => {
                                        setFilter({...filter, worker: value.id})
                                    }}
                                />
                                <Select
                                    options={priorities}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    placeholder={'Priority'}
                                    onChange={value => {
                                        setFilter({...filter, priority: value.label})
                                    }}
                                />
                            </FilterItemsContainer>
                        </FilterContainer>
                        <Button outline={true} style={{
                            backgroundColor: '#ec6409',
                            color: 'white',
                            marginTop: "10px",
                            border: '1px solid #ec6409',
                            float: 'right',
                            marginRight: '15px'
                        }} onClick={() => {
                            onChange(filter)
                        }}>Save</Button>

                    </DropdownMenu>
                </Dropdown>

            </UncontrolledDropdown>
        </Nav>
    )
}

export {
    InputKeySelect,
    InputArraySelect,
    ArraySelect,
    KeySelect,
    InputKeySideSelect,
    InputArraySideSelect,
    SelectWithoutInput,
    CustomSort,
    CustomFilter,
    InputAddressSelect,
}